import { render, staticRenderFns } from "./ResetPwdFinal.vue?vue&type=template&id=6aa9c4b1&scoped=true&"
import script from "./ResetPwdFinal.vue?vue&type=script&lang=js&"
export * from "./ResetPwdFinal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdFinal.vue?vue&type=style&index=0&id=6aa9c4b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9c4b1",
  null
  
)

export default component.exports